var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 7.66683C7.55789 7.66683 7.13397 7.49123 6.82141 7.17867C6.50885 6.86611 6.33325 6.44219 6.33325 6.00016C6.33325 5.55814 6.50885 5.13421 6.82141 4.82165C7.13397 4.50909 7.55789 4.3335 7.99992 4.3335C8.44195 4.3335 8.86587 4.50909 9.17843 4.82165C9.49099 5.13421 9.66658 5.55814 9.66658 6.00016C9.66658 6.21903 9.62348 6.43576 9.53972 6.63797C9.45596 6.84018 9.33319 7.02391 9.17843 7.17867C9.02367 7.33344 8.83993 7.4562 8.63772 7.53996C8.43551 7.62372 8.21879 7.66683 7.99992 7.66683ZM7.99992 1.3335C6.76224 1.3335 5.57526 1.82516 4.70009 2.70033C3.82492 3.5755 3.33325 4.76249 3.33325 6.00016C3.33325 9.50016 7.99992 14.6668 7.99992 14.6668C7.99992 14.6668 12.6666 9.50016 12.6666 6.00016C12.6666 4.76249 12.1749 3.5755 11.2997 2.70033C10.4246 1.82516 9.2376 1.3335 7.99992 1.3335Z",
    fill: "#959BA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.75cfa331f59b9fb129b3e67bf12efa6a.svg";
export { ForwardRef as ReactComponent };